"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const components_1 = require("./components");
const statuses = {
    ORDERED: 'store.order.status.ordered',
    PAID: 'store.order.status.paid',
    SENT: 'store.order.status.sent',
    RETURNED: 'store.order.status.returned',
    CANCELED: 'store.order.status.canceled',
    COMPLAINT: 'store.order.status.complaint',
};
function Status({ status, createdAt }) {
    var _a;
    const { t } = (0, app_1.useTranslation)();
    const statusLabel = status && statuses[status];
    return ((0, jsx_runtime_1.jsxs)(components_1.InfoWrap, Object.assign({ templateColumns: "repeat(2, minmax(0, 1fr))" }, { children: [(0, jsx_runtime_1.jsxs)(components_1.CenteredStack, Object.assign({ spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: t('label.status') })), (0, jsx_runtime_1.jsx)(components_1.DataWrap, { children: status ? ((0, jsx_runtime_1.jsx)(ui_1.Tag, { children: statusLabel ? t(statusLabel) : status })) : ((0, jsx_runtime_1.jsx)(components_1.SmallSkeleton, { rows: 1 })) })] })), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsxs)(components_1.CenteredStack, Object.assign({ spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: t.colon('label.date') })), (0, jsx_runtime_1.jsx)(components_1.DataWrap, { children: (_a = createdAt === null || createdAt === void 0 ? void 0 : createdAt.toDateString()) !== null && _a !== void 0 ? _a : (0, jsx_runtime_1.jsx)(components_1.SmallSkeleton, { rows: 1 }) })] })) })] })));
}
exports.Status = Status;
